import { createStrictContext } from 'utils/createContext'
import { useGetUsersTableDataQuery } from 'schema'
import { useGlobalState } from 'context/GlobalStateContext'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { useCIMSModalValues } from 'components/CIMSModal/hooks/useCIMSModal'
import { User, UsersTableContext } from './types'

const { Provider, useContextFn } =
  createStrictContext<UsersTableContext>('UsersTableContext')

export const useUsersTableContext = useContextFn

export const UsersTableProvider: React.FC = ({ children }) => {
  const {
    state: { projectGlobalId: projectId },
  } = useGlobalState()

  const {
    data,
    refetch,
    loading: fetching,
  } = useGetUsersTableDataQuery({
    ...DefaultQueryHookOptions,
    variables: {
      projectId: projectId!,
    },
    skip: !projectId,
  })
  return (
    <Provider
      value={{
        records: data?.project?.users ?? [],
        refetch,
        fetching,
        roles: data?.project?.roles ?? [],
        userGroups:
          data?.project?.projectToUserGroups.map(
            ({ userGroup }) => userGroup
          ) ?? [],
        customFields: data?.project?.customFields ?? [],
        editModal: useCIMSModalValues<User>(),
      }}
    >
      {children}
    </Provider>
  )
}
